import createTheme from './createTheme';
var defaultTheme = createTheme({
    palette: {
        primary: {
            darker: '#002346',
            dark: '#004166',
            main: '#005F86',
            light: '#4C8FAA',
            lighter: '#CCDFE7',
            contrast: '#FFFFFF',
        },
        secondary: {
            darker: '#055B49',
            dark: '#167A69',
            main: '#279989',
            light: '#67B7AC',
            lighter: '#D4EBE7',
            contrast: '#FFFFFF',
        },
        neutral: {
            darker: '#000000',
            dark: '#191919',
            main: '#333333',
            light: '#7F7F7F',
            lighter: '#DDDDDD',
            contrast: '#FFFFFF',
        },
        error: {
            darker: '#610608',
            dark: '#80181B',
            main: '#CD0D15',
            light: '#BB696D',
            lighter: '#ECD4D5',
            contrast: '#FFFFFF',
        },
        warning: {
            darker: '#BA7100',
            dark: '#CA8E00',
            main: '#FFE000',
            light: '#E5C34C',
            lighter: '#F8EECC',
            contrast: '#000000',
        },
        success: {
            darker: '#284D02',
            dark: '#466D0E',
            main: '#68A300',
            light: '#93AF5F',
            lighter: '#E0E8D1',
            contrast: '#FFFFFF',
        },
        paper: {
            darker: '#DDDDDD',
            dark: '#F5F5F5',
            main: '#FBFBFB',
            light: '#FEFEFE',
            lighter: '#FFFFFF',
            contrast: '#000000',
        },
    },
    dimensions: {
        borderRadius: '8px',
        borderWidth: '1px',
        margin: '8px',
        padding: '1em',
    },
    typography: {
        title1: '500 3.75rem/1 Helvetica Neue, Arial',
        title2: '400 1.875rem/1.2 Helvetica Neue, Arial',
        title3: '400 1.5rem/1.4 Helvetica Neue, Arial',
        title4: '700 1.125rem/1.4 Helvetica Neue, Arial',
        title5: '700 1rem/1.4 Helvetica Neue, Arial',
        body1: '500 1rem/1.2 Helvetica Neue, Arial',
        body2: '400 0.9rem/1.1 Helvetica Neue, Arial',
        caption: '500 0.8rem/1 Helvetica Neue, Arial',
        button: '600 0.9em/1 Helvetica Neue, Arial',
        input: '500 1rem/1.2 Helvetica Neue, Arial',
    },
    breakpoints: {
        xs: 0,
        sm: 480,
        md: 768,
        lg: 1080,
        xl: 1280,
    },
    overrides: {
        Avatar: {},
        Button: {},
        Card: {},
        Checkbox: {},
        Drawer: {},
        Dropdown: {},
        Flex: {},
        Icon: {},
        Input: {},
        Menu: {},
        Modal: {},
        Select: {},
        Slider: {},
        Switch: {},
        Radio: {},
        Table: {},
        Text: {},
        TextArea: {},
        Tooltip: {},
    },
});
export default defaultTheme;
